import React, { Component } from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';

import List from './List';
import Form from './Form';

interface IProps {
  fetchSuppliers: () => void;
  history: any;
  loading: boolean;
}
interface IState {}

class Suppliers extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {};
  }

  public componentDidMount() {
    const { fetchSuppliers } = this.props;

    fetchSuppliers();
  }

  public render() {
    const { history } = this.props;

    return (
      <div className="dashboard-container">
        <Router history={history}>
          <Switch>
            <Route path="/dashboard/suppliers" exact component={List} />
            <Route path="/dashboard/suppliers/list" exact component={List} />
            <Route path="/dashboard/suppliers/new" exact render={() => <Form history={history} />} />
            <Route path="/dashboard/suppliers/supplierid/:supplierid/edit" exact render={(props) => <Form history={history} supplierid={props.match.params.supplierid} />} />
            <Redirect to="/authenticate" />
          </Switch>
        </Router>
      </div>
    );
  }
};

export default Suppliers;